import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveSession, getSession } from '../components/ProtectedRoute.jsx';


export default function Enquestador() {
  const navigate = useNavigate();
  const [enquestadors, setEnquestadors] = useState([]);
  const [seleccionat, setSeleccionat] = useState('');
  const [mostrarNou, setMostrarNou] = useState(false);
  const [nomNou, setNomNou] = useState('');
  const [errorNou, setErrorNou] = useState('');

  useEffect(() => {
    const session = getSession();
    if (session && session.enquestador_nom) {
      navigate('/app', { replace: true });
    }
  }, []);

  useEffect(() => {
    fetch('/api/encuestadors')
      .then(r => r.json())
      .then(data => {
        setEnquestadors(data);
        if (data.length > 0) setSeleccionat(data[0].nom);
      });
  }, []);

  function handleAccedir(e) {
    e.preventDefault();
    if (!seleccionat) return;
    saveSession(seleccionat);
    navigate('/app', { replace: true });
  }

  async function handleGuardarNou(e) {
    e.preventDefault();
    setErrorNou('');
    if (!nomNou.trim()) return;
    try {
      const res = await fetch('/api/encuestadors', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nom: nomNou.trim() }),
      });
      const data = await res.json();
      if (!res.ok) {
        setErrorNou(data.error || 'Error en guardar');
        return;
      }
      setEnquestadors(prev => [...prev, data].sort((a, b) => a.nom.localeCompare(b.nom)));
      setSeleccionat(data.nom);
      setNomNou('');
      setMostrarNou(false);
    } catch {
      setErrorNou('Error de connexió');
    }
  }

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-6">
          <img
            src="/logomontcadayreixac.png"
            alt="Ajuntament de Montcada i Reixac"
            className="h-24 object-contain"
          />
        </div>

        <h1 className="text-xl font-semibold text-gray-800 text-center mb-1">
          Cens de Comerços
        </h1>
        <p className="text-gray-500 text-center mb-6">Bon dia! Com et dius?</p>

        <form onSubmit={handleAccedir} className="space-y-4">
          <select
            value={seleccionat}
            onChange={e => setSeleccionat(e.target.value)}
            className="w-full rounded-lg px-4 py-3 text-base min-h-[44px] focus:outline-none"
            style={{ border: '1px solid #DF273F' }}
          >
            {enquestadors.map(e => (
              <option key={e.id} value={e.nom}>{e.nom}</option>
            ))}
          </select>

          <button
            type="submit"
            className="w-full bg-dark text-white rounded-lg py-3 text-base font-medium min-h-[44px]"
          >
            Accedir
          </button>
        </form>

        {!mostrarNou ? (
          <button
            onClick={() => setMostrarNou(true)}
            className="mt-4 w-full text-sm text-accent hover:opacity-75 text-center"
          >
            + Afegir nou enquestador
          </button>
        ) : (
          <form onSubmit={handleGuardarNou} className="mt-4 space-y-2">
            <input
              type="text"
              value={nomNou}
              onChange={e => setNomNou(e.target.value)}
              placeholder="Nom del nou enquestador"
              className="w-full rounded-lg px-4 py-3 text-base focus:outline-none"
              style={{ border: '1px solid #DF273F' }}
              autoFocus
            />
            {errorNou && <p className="text-red-600 text-sm">{errorNou}</p>}
            <div className="flex gap-2">
              <button
                type="submit"
                className="flex-1 bg-dark text-white rounded-lg py-2 text-sm min-h-[44px]"
              >
                Guardar
              </button>
              <button
                type="button"
                onClick={() => { setMostrarNou(false); setNomNou(''); setErrorNou(''); }}
                className="flex-1 text-accent rounded-lg py-2 text-sm min-h-[44px]"
                style={{ border: '1px solid #DF273F' }}
              >
                Cancel·lar
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
